import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createSuper";
import { ValueWithRandom } from "../../ValueWithRandom";
export var LifeDelay = /*#__PURE__*/function (_ValueWithRandom) {
  _inherits(LifeDelay, _ValueWithRandom);
  var _super = _createSuper(LifeDelay);
  function LifeDelay() {
    var _this;
    _classCallCheck(this, LifeDelay);
    _this = _super.call(this);
    _this.sync = false;
    return _this;
  }
  _createClass(LifeDelay, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }
      _get(_getPrototypeOf(LifeDelay.prototype), "load", this).call(this, data);
      if (data.sync !== undefined) {
        this.sync = data.sync;
      }
    }
  }]);
  return LifeDelay;
}(ValueWithRandom);